var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies"},[_c('SectionHeader',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('BreadCrumbs',{attrs:{"items":[
          { text: _vm.$t('meta.sites'), name: 'company_sites' },
          {
            text: _vm.area.site && _vm.area.site.name,
            name: 'site',
            params: { site_uuid: _vm.$route.params.site_uuid },
          },
          { text: _vm.area.name } ]}})]},proxy:true}])}),_c('div',{staticClass:"body-content"},[_c('CompanyNav'),_c('div',{staticClass:"body"},[(_vm.loading)?_c('LoadingSpinner'):_c('div',[_c('AreaForm',{attrs:{"initialArea":_vm.area,"site":_vm.area.site,"zones":_vm.zones},on:{"submit":_vm.updateArea}}),_c('ZoneIndex',{attrs:{"area":_vm.area}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }